import { Button, IconButton, Tooltip, withStyles } from "@material-ui/core";
import { DateTime } from "./ReceivingHours";
import { EventBusyOutlined } from "@material-ui/icons";
import capitalize from 'lodash/capitalize';
import { MoreTimeOutlined } from "../../../Common/icons";

const styles = (theme) => ({
  disabledDefaultHours: {
    opacity: 0.4,
    pointerEvents: "none",
  },
  closeIcon: {
    "&:hover": {
      color: theme.error,
    },
    color: theme.iconColor,
    alignSelf: "flex-end",
    padding: 4
  },
  timeRangeEditorStyle: {
    marginBottom: 10,
    marginLeft: -5,
  },
  defaultHours: {
    color: theme.ErrorMessageColor,
  },
  defaultHoursContainer: {
    display: "flex",
    alignItems: "center",
    paddingBottom: 8
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: 8
  },
  disableCloseIcon: {
    opacity: 0.7
  },
  dialogButtonStyle: {
    fontSize: theme.textFontSize,
    textTransform: 'none',
    '&$disabledButton': {
      color: theme.TextColor,
      opacity: 0.8,
    },
  },
  disabledButton: {},
});

const DayOfWeekHoursInput = ({
  hasHours,
  markDefaultHoursClosed,
  isDefaultHoursClosed,
  classes,
  defaultHoursError,
  addDayOfWeekHours,
  updateDefaultHours,
  defaultHours,
  isDeliveriesTabActive
}) => {
  const addHours = () => {
    updateDefaultHours([...defaultHours, ""]);
  };

  const updateHours = (index, hour) => {
    const updatedValues = [...defaultHours];
    updatedValues[index] = hour;
    updateDefaultHours(updatedValues);
  };
  const isDisabledAddMoreDefaultHours = defaultHours.length >= 2;
  return (
    <div className={hasHours ? classes.disabledDefaultHours : ''}>
      <div className={classes.defaultHoursContainer}>
        {capitalize('Default hours')}
        {!isDefaultHoursClosed ? (
          <div className={classes.iconContainer}>
            {isDeliveriesTabActive && (
              <Tooltip title="Add Additional Default Hours">
                <IconButton
                  onClick={addHours}
                  classes={{ root: classes.closeIcon }}
                  disabled={isDisabledAddMoreDefaultHours}
                  className={isDisabledAddMoreDefaultHours ? classes.disableCloseIcon : ''}>
                  <MoreTimeOutlined />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Mark Permanently Closed">
              <IconButton onClick={markDefaultHoursClosed} classes={{ root: classes.closeIcon }}>
                <EventBusyOutlined />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          <>
            <br />
            <br />
          </>
        )}
      </div>
      {defaultHours.map((hour, index) => (
        <div key={index}>
          <div className={classes.timeRangeEditorStyle}>
            <DateTime
              isClosedDay={isDefaultHoursClosed}
              time={hour}
              index={index}
              key={`closed_${hour}`}
              updateTime={updateHours}
              autoFocus={!hasHours && index === 0}
            />
          </div>
          {defaultHoursError?.[index] ? (
            <div className={classes.defaultHours}>{defaultHoursError?.[index]}</div>
          ) : null}
        </div>
      ))}
      {hasHours ? null : (
        <Button
          id="addDayOfWeekHours"
          color="primary"
          variant="text"
          onClick={addDayOfWeekHours}
          classes={{
            root: classes.dialogButtonStyle,
            disabled: classes.disabledButton
          }}
          disabled={defaultHoursError.filter(Boolean).length}>
          + Add Day of the Week {isDeliveriesTabActive ? 'Receiving' : 'Shipping'} Hours
        </Button>
      )}
    </div>
  );
};

export default withStyles(styles)(DayOfWeekHoursInput);